import React, { useState } from "react";

function Navbar() {
  const [darkMode, setDarkMode] = useState(false);

  const toggleDarkMode = () => {
    setDarkMode(!darkMode);
    document.documentElement.classList.toggle("dark");
  };

  return (
    <nav className="fixed w-full backdrop-blur-md bg-white/30 dark:bg-gray-900/70 shadow-md z-50">
      <div className="max-w-6xl mx-auto flex justify-between items-center p-4">

        <h1 className="text-2xl font-bold text-blue-600 dark:text-white">
          Vyankatesh.dev
        </h1>

        <div className="flex items-center gap-6">
          <ul className="flex space-x-6 font-medium">
            <li><a href="#about" className="py-20 text-center dark:text-white">About</a></li>
            <li><a href="#services" >Services</a></li>
            <li><a href="#projects" >Projects</a></li>
            <li><a href="#contact" >Contact</a></li>
          </ul>

          <button 
            onClick={toggleDarkMode}
            className="bg-gray-200 dark:bg-gray-700 px-3 py-1 rounded"
          >
            🌙
          </button>
        </div>

      </div>
    </nav>
  );
}

export default Navbar;